import { useTranslation } from 'react-i18next';

import CustomInput, { Props as CustomInputProps } from '../../../../components/CustomInput/CustomInput';
import { StyledP } from './styled';

interface Props {
    baseInputProps: Omit<CustomInputProps, 'name'>;
}

const Form = (props: Props) => {
    const { baseInputProps } = props;

    const { t } = useTranslation();

    return (
        <>
            <StyledP>{t('dialogs.reset_password.description')}</StyledP>
            <CustomInput {...baseInputProps} name='email' />
        </>
    );
};

export default Form;
